<template>
  <div>
    <template v-if="showAttributes.length">
      <div v-for="(item, I) in showAttributes" :key="I">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">
            <span v-if="item.owner != 'self'">{{ $t(item.group) }}</span>
            <input
              v-else
              type="text"
              :placeholder="this.$t('page.product-library.PleaseEnterAGroupName')"
              v-model="item.group"
              style="width: 21.5%"
              :class="[
                'form-control',
                submitted &&
                  (!item.group || item.group.length > 50) &&
                  'is-invalid',
                !(submitted && (!item.group || item.group.length > 50)) &&
                  'mb-3',
              ]"
            />
            <div
              v-show="submitted && (!item.group || item.group.length > 50)"
              class="invalid-feedback"
            >
              <span>{{
                !item.group
                  ? validationTips.nameNotNull
                  : validationTips.charLengthLE50
              }}</span>
            </div>
          </h4>
        </div>
        <div class="d-flex mt-2">
          <div class="flex-grow-1 me-2">
            <div class="row">
              <div
                class="col"
                v-for="(title, i) in titleList"
                :key="i"
                :style="{ opacity: title.name == this.$t('page.device.name') ? 0 : 1 }"
              >
                <span class="text-danger" v-if="title.required">* </span>
                <label class="form-label">{{ title.name }}</label>
              </div>
            </div>
          </div>
          <!-- 占位 -->
          <div class="opacity-0">
            <b-button
              variant="primary"
              class="pb-0"
              size="sm"
              style="min-width: 4.5rem"
              >{{this.$t('page.solid')}}</b-button
            >
          </div>
        </div>
        <div class="d-flex" v-for="(attr, i) in item.list" :key="i">
          <div class="flex-grow-1 me-2">
            <div class="row">
              <div class="col">
                <span
                  v-if="(formType && attr.disabled) || attr.owner != 'self'"
                  class="ms-3"
                  >{{ $t(attr.name) }}</span
                >
                <input
                  type="text"
                  v-else
                  :class="[
                    'form-control',
                    submitted &&
                      (!attr.name || attr.name.length > 50) &&
                      'is-invalid',
                    !(submitted && (!attr.name || attr.name.length > 50)) &&
                      'mb-3',
                  ]"
                  :disabled="attr.owner != 'self'"
                  :placeholder="this.$t('page.product-library.PleaseEnterAPropertyName')"
                  v-model="attr.name"
                />
                <div
                  v-show="submitted && (!attr.name || attr.name.length > 50)"
                  class="invalid-feedback"
                >
                  <span>{{
                    !attr.name
                      ? validationTips.nameNotNull
                      : validationTips.charLengthLE50
                  }}</span>
                </div>
              </div>
              <div class="col el-box">
                <Multiselect
                  v-if="
                    attr.name == '设备状态' ||
                    attr.name == '应用行业' ||
                    attr.name == '客户属性' ||
                    attr.name == '客户行业'
                  "
                  class="mb-3"
                  v-model="attr.default"
                  :close-on-select="true"
                  :searchable="true"
                  :canClear="true"
                  :placeholder="this.$t('page.product-library.SelectADefaultValueForTheProperty')"
                  :options="industryOptions(attr)"
                />
                <el-select
                  class="mb-3"
                  v-else-if="attr.name == '维保服务商'"
                  v-model="attr.default"
                  @change="maintenanceServiceProviderChange"
                  @focus="serviceCompany"
                  filterable
                  clearable
                  style="width: 100%; line-height: 37.5px"
                  size="large"
                  :placeholder="this.$t('page.tending.select_service_provider')"
                >
                  <el-option
                    v-for="option in maintenanceServiceProvider"
                    :label="option['label']"
                    :value="option['value']"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <el-select
                  class="mb-3"
                  v-else-if="attr.name == '客户名称'"
                  v-model="attr.default"
                  @focus="customerFocus"
                  @change="clientChange"
                  style="width: 100%; line-height: 37.5px"
                  filterable
                  clearable
                  size="large"
                  :placeholder="this.$t('base.select_customer')"
                >
                  <el-option
                    v-for="option in clientName"
                    :label="option['label']"
                    :value="option['value']"
                    :key="option.value"
                  ></el-option>
                </el-select>
                <Multiselect
                  v-else-if="attr.name == '客户采购联系人'"
                  class="mb-3"
                  v-model="attr.default"
                  :close-on-select="true"
                  :searchable="true"
                  :canClear="true"
                  :placeholder="this.$t('page.product-library.SelectADefaultValueForTheProperty')"
                  :options="customerContact"
                  @change="customerContactChange"
                />
                <!-- <flat-pickr
                  v-else-if="I==1 && (i == 2 || i ==3)"
                  v-model="attr.default"
                  placeholder="请选择属性默认值"
                  :config="rangeDateconfig"
                  class="form-control flatpickr-input mb-3"
                ></flat-pickr> -->
                <el-date-picker
                  v-else-if="
                  I == 1 &&
                  (
                    attr.name == '发货时间' ||
                    attr.name == '设备创建时间' ||
                    attr.name == '质保到期时间'
                  )"
                  v-model="attr.default"
                  type="date"
                  class="datapicker mb-3 w-100"
                  :placeholder="this.$t('page.product-library.SelectADefaultValueForTheProperty')"
                  :format="altFormat"
                  :value-format="altFormat"
                />
                <input
                  v-else
                  type="text"
                  :class="[
                    'form-control',
                    !(
                      submitted &&
                      ((attr.default && attr.default.length > 50) ||
                        (attr.dataValidation && attr.dataValidation.type))
                    ) && 'mb-3',
                    submitted &&
                      ((attr.default && attr.default.length > 50) ||
                        (attr.dataValidation && attr.dataValidation.type)) &&
                      'is-invalid',
                  ]"
                  :placeholder="this.$t('page.product-library.PleaseEnterTheDefaultValueOfTheProperty')"
                  v-model="attr.default"
                  :disabled="attr.name == '序列号'"
                />

                <div
                  v-show="
                    submitted &&
                    ((attr.default && attr.default.length > 50) ||
                      (attr.dataValidation && attr.dataValidation.type))
                  "
                  class="invalid-feedback"
                >
                  <span v-if="attr.default && attr.default.length > 50">{{
                    validationTips.charLengthLE50
                  }}</span>
                  <span v-else>
                    {{ attr.dataValidation && attr.dataValidation.typeError }}
                  </span>
                </div>
              </div>
              <div class="col">
                <Multiselect
                  v-model="attr.unit"
                  :close-on-select="true"
                  :searchable="true"
                  :create-option="true"
                  :canClear="true"
                  :options="unitOptions"
                  :disabled="attr.owner != 'self'"
                />
              </div>
              <div class="col">
                <Multiselect
                  :class="[submitted && !attr.dtype && 'is-invalid']"
                  v-model="attr.dtype"
                  :close-on-select="true"
                  :searchable="false"
                  :canClear="false"
                  :options="dataTypes"
                  :disabled="attr.owner != 'self'"
                />
                <div v-show="submitted && !attr.dtype" class="invalid-feedback">
                  <span>{{ validationTips.dataTypeNotNull }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="position-relative">
            <b-button
              variant="primary"
              size="sm"
              :style="{
                minWidth: '4.5rem',
                marginTop: ' 0.34rem',
                opacity: attr.owner != 'self' ? 0 : 1,
              }"
              :disabled="attr.owner != 'self'"
              @click="tagMessageBox = `${I}-${i}`"
              >{{ $t('base.delete') }}</b-button
            >
            <MessageBox
              v-if="tagMessageBox == `${I}-${i}`"
              :messageCont="`${this.$t('page.product-library.AreYouSureWantDelete')}？`"
              :messageIcon="'ri-error-warning-line'"
              :iconStyle="{ fontSize: '14px', color: '#f06548' }"
              :messageStyle="{ top: '-5rem', left: '-5.5rem' }"
              @makeSure="handleDelete(I, i)"
              @makeClose="tagMessageBox = null"
            ></MessageBox>
          </div>
        </div>
        <div class="text-center mt-2">
          <b-button variant="primary" @click="handleAdd(I)">{{this.$t('base.add_attribute')}}</b-button>
        </div>
      </div>
      <b-button variant="primary" @click="handleAddGroup" class="ms-3"
        >{{this.$t('base.AddGroup')}}</b-button
      >
    </template>
  </div>
</template>

<script>
/* import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css"; */
import { ElDatePicker } from "element-plus";
import "element-plus/theme-chalk/el-date-picker.css";
import "element-plus/es/components/date-picker/style/css";
import MessageBox from "@/components/common/MessageBox.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import { getCustomerOptions, customerDetail, getCustomerContacts } from "@/service";
import { getCompany } from "@/helpers/common-service";

export default {
  directives: {
    // 这里实现一个组件内部的自定义指令
    // loadmore: {
    //   // 指令的定义
    //   mounted(el, binding) {
    //     console.log(el)
    //     const SELECTWRAP = document.querySelector(
    //       ".el-select-customer .el-select-dropdown .el-select-dropdown__wrap"
    //     );
    //     if (!SELECTWRAP) {
    //       throw new Error('获取不到"el-select-dropdown__wrap"节点');
    //     }
    //     SELECTWRAP.addEventListener("scroll", () => {
    //       // scrollTop  这里可能因为浏览器缩放存在小数点的情况，导致了滚动到底部时
    //       // scrollHeight 减去滚动到底部时的scrollTop ，依然大于clientHeight 导致无法请求更多数据
    //       // 这里将scrollTop向上取整 保证滚到底部时，触发调用
    //       const CONDITION =
    //         SELECTWRAP.scrollHeight - Math.ceil(SELECTWRAP.scrollTop) <=
    //         SELECTWRAP.clientHeight;
    //       // el.scrollTop !== 0 当输入时，如果搜索结果很少，以至于没看到滚动条，那么此时的CONDITION计算结果是true，会执行bind.value()，此时不应该执行，否则搜索结果不匹配
    //       if (CONDITION && SELECTWRAP.scrollTop !== 0) {
    //         binding.value();
    //       }
    //     });
    //   },
    // },
  },
  emits: ["update:attributes", "getCustomerid"],
  props: {
    submitted: Boolean,
    dataTypes: Array,
    equipStatus: Array,
    equipDisciplineClass: Array,
    units: Array,
    validationTips: Object,
    dataValidation: Object,
    attributes: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup() {

  },
  components: {
    MessageBox,
    Multiselect,
    ElDatePicker,
    // flatPickr
  },
  watch: {
    showAttributes: {
      handler(newVal) {
        this.$emit("update:attributes", newVal);
        console.log(this.showAttributes);
      },
      deep: true,
    },
    attributes: {
      handler(newVal) {
        // console.log(newVal);
        this.showAttributes = newVal
        this.dealAttrs()
        this.getValues()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      titleList: [
        {
          name: this.$t('page.device.name'),
          required: true,
        },
        {
          name: this.$t('page.product-library.DefaultVlue'),
          required: false,
        },
        {
          name: this.$t('page.work-order.device.unit'),
          required: false,
        },
        {
          name: this.$t('base.data_type'),
          required: true,
        },
      ],
      formType: null,
      showAttributes: [],
      tagMessageBox: null,
      altFormat: "YYYY/MM/DD", //选择时显示的时间
      rangeDateconfig: {
        wrap: true,
        altFormat: "Y/m/d", //选择时显示的时间
        altInput: true,
        dateFormat: "Y/m/d",
      },
      maintenanceServiceProvider: [],
      clientName: [],
      clientList: [],
      customerContact: [],
      customer_id: "",
      service_company_id: "",
      keyword: "", // 存储关键字用
      loading: false,
      page: 1,
      hasMore: true,
    };
  },
  mounted() {
    this.formType = _.get(this.$route, ["query", "type"]);
  },
  computed: {
    unitOptions() {
      return this.units.map((item) => {
        return {
          label: (!item || item === '无' || item === 'None') ? this.$t('page.no') : item,
          value: (item === '无' || item === 'None') ? '' : item,
        };
      });
    },
  },
  methods: {
    dealAttrs() {
      if (!this.showAttributes || !this.showAttributes.length) return
      // 没有序列号时将属性中的泵头序列号和机组序列号替换为序列号
      if (!_.some(this.showAttributes[0].list, ['name', '序列号'])) {
        let snIndex = []
        this.showAttributes[0].list.map((item, index) => {
          if (item.name === '泵头序列号' || item.name === '机组序列号') {
            item.name = '序列号'
            snIndex.push(index)
          }
        });
        if (snIndex.length > 1) {
          this.showAttributes[0].list.splice(snIndex[1], 1)
        }
      }
      // 把所有unit为无或者None的替换为''
      this.showAttributes.map((group) => {
        group.list.map(item => {
          if (item.unit === '无' || item.unit === 'None') {
            item.unit = ''
          }
        })
      })
    },
    customerFocus() {
      if (this.clientName && this.clientName.length > 0) return

      getCustomerOptions({page_size: 0})
        .then((res) => {
          this.clientName = [];
          this.clientList = [];
          this.clientList = res.payload;
          res.payload.map((a) => {
            this.clientName.push({
              label: a.name,
              value: a.name,
              key: a.id + "",
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectList(i) {
      return i == 4 ? this.equipStatus : this.equipDisciplineClass;
    },
    handleAddGroup() {
      let defaultGroup = {
        group: "",
        owner: "self",
        list: [
          {
            id: uuidv4(),
            name: "",
            owner: "self",
            default: "",
            unit: '',
            dtype: "string",
          },
        ],
      };
      this.showAttributes.push({ ...defaultGroup });
    },
    handleAdd(I) {
      this.tagMessageBox = null;

      let defaultData = {
        owner: "self",
        id: uuidv4(),
        name: "",
        default: "",
        unit: '',
        dtype: "string",
        disabled: false,
      };
      this.showAttributes[I].list.push({ ...defaultData });
      console.log(this.showAttributes);
    },
    handleDelete(I, i) {
      if (this.showAttributes[I].list.length === 1) {
        this.showAttributes.splice(I, 1);
      } else {
        this.showAttributes[I].list.splice(i, 1);
      }
      this.tagMessageBox = null;
    },
    serviceCompany() {
      if (this.maintenanceServiceProvider && this.maintenanceServiceProvider.length > 0) return
      getCompany()
        .then((res) => {
          this.maintenanceServiceProvider = [];
          res.map((a) => {
            this.maintenanceServiceProvider.push({
              label: a.name,
              value: a.name,
              key: a.id + "",
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getValues() {
      if (!this.maintenanceServiceProvider || this.maintenanceServiceProvider.length === 0) {
        getCompany()
          .then((res) => {
            this.maintenanceServiceProvider = [];
            res.map((a) => {
              this.maintenanceServiceProvider.push({
                label: a.name,
                value: a.name,
                key: a.id + "",
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (!this.clientName || this.clientName.length === 0) {
        getCustomerOptions({ page_size: 0 })
        .then((res) => {
          this.clientName = [];
          res.payload.map((a) => {
            this.clientName.push({
              label: a.name,
              value: a.name,
              key: a.id + "",
            });

            //   _.get(this.attributes,[2,'list']).map(b=>{
            //      if(b.default==a.name){
            //          console.log(b,a)
            //      getCustomerContacts({
            //           customer: a.id,
            //           page_size: 0,
            //         })
            //           .then((ress) => {
            //             this.customerContact = [];
            //             ress.payload.map((item) => {
            //               this.customerContact.push({
            //                 label: item.name,
            //                 value: item.name,
            //                 key: item.tel + "",
            //               });
            //             });
            //           })
            //           .catch((err) => {
            //             console.log(err);
            //           });

            // }

            // })
          });
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    customerContactChange(e) {
      var tel = _.get(
        this.customerContact.filter((item) => {
          return item.value == e;
        }),
        [0, "key"]
      );
      console.log(this.customerContact, e, tel);
      this.showAttributes[2].list.map((item) => {
        if (item.name == '客户采购联系人电话') {
          item.default = tel;
        }
      });
    },
    clientChange(e) {
      this.customer_id = _.get(
        this.clientName.filter((item) => {
          return item.value == e;
        }),
        [0, "key"]
      );
      this.$emit("getCustomerid", {
        customer_id: this.customer_id,
        service_company_id: this.service_company_id,
      });
      if (this.customer_id) {
        customerDetail(this.customer_id)
          .then((res) => {
            this.showAttributes[2].list.map((item) => {
              if (item.name == '客户编码') {
                item.default = res.payload.code;
              }
              if (item.name == '客户属性') {
                item.default = res.payload.attribute;
              }
              if (item.name == '客户行业') {
                item.default = res.payload.industry;
              }
              if (item.name == '所在位置') {
                item.default = res.payload.country_txt + res.payload.city_txt + res.payload.province_txt;
              }
              if (item.name == '客户地址') {
                item.default = res.payload.address;
              }
              if (item.name == '客户电话') {
                item.default = res.payload.tel;
              }
              if (item.name == '客户邮箱') {
                item.default = res.payload.email;
              }
              if (item.name == '客户官网') {
                item.default = res.payload.home_url;
              }
            });
          })
          .catch((err) => {
            console.log(err);
          })

        getCustomerContacts({ customer: this.customer_id, page_size: 0, label: '采购联系人' })
          .then((res) => {
            this.customerContact = [];
            res.payload.map((a) => {
              this.customerContact.push({
                label: a.name,
                value: a.name,
                key: a.tel + "",
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });

      } else {
        this.customerContact = [];
        this.showAttributes[2].list.map((item) => {
          if (item.name == '客户编码') {
            item.default = '';
          }
          if (item.name == '客户属性') {
            item.default = '';
          }
          if (item.name == '客户行业') {
            item.default = '';
          }
          if (item.name == '所在位置') {
            item.default = '';
          }
          if (item.name == '客户地址') {
            item.default = '';
          }
          if (item.name == '客户电话') {
            item.default = '';
          }
          if (item.name == '客户邮箱') {
            item.default = '';
          }
          if (item.name == '客户官网') {
            item.default = '';
          }
        });
      }

    },
    maintenanceServiceProviderChange(e) {
      this.service_company_id = _.get(
        this.maintenanceServiceProvider.filter((item) => {
          return item.value == e;
        }),
        [0, "key"]
      );
      this.$emit("getCustomerid", {
        customer_id: this.customer_id,
        service_company_id: this.service_company_id,
      });
    },
    //应用行业Options翻译
    industryOptions(attr){
        let  reslut = []
        if(attr.name == '应用行业' && attr.options && this.$route.query.type == "edit"){ //只在编辑页，创建页面已经翻译。
            reslut = attr.options.map(item=>{
                return { label: this.$t(`overview_dynamic.industy_dict['${item.label}']`),value:item.value}
            })
        }else{
            let list = _.cloneDeep(attr.options)
            if(list) {
                reslut = list.map(v => v.label = this.$t(v.label))
            }
        }
        
        return reslut;
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.datapicker .el-input__inner) {
  padding: 0 15px;
  height: 36px !important;
  // border:1px solid #ced4da !important;
  color: #212529 !important;
  &::placeholder {
    color: #7c7f8e;
    font-size: 0.8125rem;
  }
  &:focus {
    border-color: #b3c8f3 !important;
  }
}
:deep(.datapicker .el-input__prefix) {
  right: 5px;
  left: unset;
}
:deep(.datapicker .el-input__suffix) {
  right: 25px;
}
</style>
